(function () {
  function initBlogSlider() {
    const swiperEl = document.querySelector('.blog-swiper');
    if (!swiperEl || swiperEl._swiperInitialized) return;
    swiperEl._swiperInitialized = true;

    const c = window.blogSliderConfig || {};

    const desktopSlides       = c.desktopSlides       || 4;
    const desktopSpace        = c.desktopSpace        ?? -90;
    const desktopCentered     = c.desktopCentered     !== false;
    const desktopDepth        = c.desktopDepth        !== false;
    const largeTabletSlides   = c.largeTabletSlides   || 2;
    const largeTabletSpace    = c.largeTabletSpace    ?? -60;
    const largeTabletCentered = c.largeTabletCentered !== false;
    const largeTabletDepth    = c.largeTabletDepth    !== false;
    const tabletSlides        = c.tabletSlides        || 3;
    const tabletSpace         = c.tabletSpace         ?? -60;
    const tabletCentered      = c.tabletCentered      !== false;
    const tabletDepth         = c.tabletDepth         !== false;
    const mobileSlides        = c.mobileSlides        || 1.2;
    const mobileSpace         = c.mobileSpace         ?? 16;
    const mobileCentered      = c.mobileCentered      || false;
    const mobileDepth         = c.mobileDepth         || false;
    const speed               = c.speed               || 500;
    const showArrows          = c.showArrows          !== false;
    const showDots            = c.showDots            !== false;
    const showArrowsMobile    = c.showArrowsMobile    || false;
    const showDotsMobile      = c.showDotsMobile      !== false;

    function getBreakpoint() {
      const w = window.innerWidth;
      if (w >= 1200) return 'desktop';
      if (w >= 980)  return 'large-tablet';
      if (w >= 768)  return 'tablet';
      return 'mobile';
    }

    function getCurrentDepth() {
      const bp = getBreakpoint();
      if (bp === 'desktop')      return desktopDepth;
      if (bp === 'large-tablet') return largeTabletDepth;
      if (bp === 'tablet')       return tabletDepth;
      return mobileDepth;
    }

    function updateDepthClass() {
      if (getCurrentDepth()) {
        swiperEl.classList.remove('no-depth');
      } else {
        swiperEl.classList.add('no-depth');
      }
    }

    function updateNavVisibility() {
      const isMobile = window.innerWidth < 768;
      const arrows = document.querySelectorAll('.blog-swiper-prev, .blog-swiper-next');
      const dots = document.querySelector('.blog-swiper-pagination');

      arrows.forEach(el => {
        el.style.visibility = isMobile
          ? (showArrowsMobile ? 'visible' : 'hidden')
          : (showArrows ? 'visible' : 'hidden');
      });

      if (dots) {
        const show = isMobile ? showDotsMobile : showDots;
        dots.style.setProperty('display', show ? 'flex' : 'none', 'important');
      }
    }

    function updateSlideDepth() {
      const slides      = this.slides;
      const activeIndex = this.activeIndex;
      slides.forEach((slide, i) => {
        const distance = Math.abs(i - activeIndex);
        slide.setAttribute('data-depth', distance);
      });
    }

    new Swiper('.blog-swiper', {
      slidesPerView:  mobileSlides,
      centeredSlides: mobileCentered,
      spaceBetween:   mobileSpace,
      speed:          speed,
      loop:           true,
      grabCursor:     true,

      pagination: {
        el:        '.blog-swiper-pagination',
        clickable: true,
      },
      navigation: {
        prevEl: '.blog-swiper-prev',
        nextEl: '.blog-swiper-next',
      },

      breakpoints: {
        768: {
          slidesPerView:  tabletSlides,
          spaceBetween:   tabletSpace,
          centeredSlides: tabletCentered,
        },
        980: {
          slidesPerView:  largeTabletSlides,
          spaceBetween:   largeTabletSpace,
          centeredSlides: largeTabletCentered,
        },
        1200: {
          slidesPerView:  desktopSlides,
          spaceBetween:   desktopSpace,
          centeredSlides: desktopCentered,
        },
      },

      on: {
        init: function () {
          updateSlideDepth.call(this);
          updateNavVisibility();
          updateDepthClass();
        },
        slideChange: updateSlideDepth,
      },
    });

    window.addEventListener('resize', function () {
      updateNavVisibility();
      updateDepthClass();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogSlider);
  } else {
    initBlogSlider();
  }
})();